import ConfidenceDropdown from './ConfidenceDropdown'

export default ConfidenceDropdown
export { DEFAULT_TITLE as CONFIDENCE_TITLE } from './ConfidenceDropdown'
